import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { getContentLocale, getUiLocale } from '@@scripts/store/settings/useSettingsStore';

import { LEAGUE_TYPE } from '../-components/constants';
import { leagueListQuery } from '../-components/teamListQuery';
import { TeamTypeLayout } from '../-components/TeamTypeLayout';

export const Route = createFileRoute('/_authenticated/teams/leaguesAndTournaments')({
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => ({
        // Built on every load, so the options follow the languages as well as the search
        listQuery: leagueListQuery(search.q, {
            contentLocale: getContentLocale(),
            uiLocale: getUiLocale(),
        }),
    }),
    loader: ({ context }) => {
        context.queryClient.infiniteQuery(context.listQuery).catch(doNothing());
    },
    component: () => <TeamTypeLayout team={LEAGUE_TYPE} />,
});
